module.exports = __webpack_public_path__ + "img/winter.bc93a085.png";